import React, { Component } from 'react'
import './approve.css'
import PopUp from '../round/PopUp'
import Upload from '../round/Upload'
import ChangeFormSchool from '../../style/file/ChangeText/信息变更申请表（航校）.docx'
import ChangeFormCenter from '../../style/file/ChangeText/信息变更申请表（训练中心）.docx'
import ChangeFormDevice from '../../style/file/ChangeText/信息变更申请表（设备）.docx'
import { post } from '../../ajax/tools'

class ChangeApprove extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ApproveType: '',
      ApproveId: '',
      ApproveItemMsg: '',
      Uploading: false,
      UploadBtnState: 'NotShow',
      FileList: [],
      NewApproveStepName: '',
      NewApproveStep: 1,
      FileName2: '',
      DownloadBag: '',
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {}

  componentDidMount = function () {
    const history = this.props
    if (history.NewApproveStep === 7) {
      this.setState({
        NewApproveStepName: '专家组审核',
      })
    } else if (history.NewApproveStep === 8) {
      this.setState({
        NewApproveStepName: '审核完成',
      })
    }
    let DownloadBag
    if (history.NewApproveIdt === '青少年航校') {
      DownloadBag = ChangeFormSchool
    } else if (history.NewApproveIdt === '训练中心') {
      DownloadBag = ChangeFormCenter
    } else if (history.NewApproveIdt === '设备') {
      DownloadBag = ChangeFormDevice
    }

    this.setState({
      ApproveType: history.NewApproveIdt,
      ApproveId: history.ApproveId,
      NewApproveStep: history.NewApproveStep,
      DownloadBag,
    })
  }

  getFileName = () => {
    const { ApproveType } = this.state
    switch (ApproveType) {
      case '青少年航校':
        return '信息变更申请表（航校）.docx'
      case '训练中心':
        return '信息变更申请表（训练中心）.docx'
      case '设备':
        return '信息变更申请表（设备）.docx'
      default:
        return '信息变更申请表.docx'
    }
  }

  // 提交修改申请
  submitChangeBtn() {
    const formData = new FormData()
    let IdtType = this.state.ApproveType
    let IdtTypeId = null
    switch (IdtType) {
      case '设备':
        IdtTypeId = 1
        break
      case '训练中心':
        IdtTypeId = 2
        break
      case '青少年航校':
        IdtTypeId = 3
        break
      default:
        IdtTypeId = null
    }

    if (this.state.FileList.length !== 0) {
      this.setState({ Uploading: true })

      formData.append('train_id', this.state.ApproveId)

      this.state.FileList.forEach((file) => {
        formData.append('file', file)
      })

      post({
        url: 'agency/up_suborg_form/' + IdtTypeId,
        data: formData,
      })
        .then((res) => {
          if (res.errno === '200') {
            this.setState({
              FileList: [],
              Uploading: false,
              UploadBtnState: 'NotShow',
              NewApproveStep: 7,
              NewApproveStepName: '人工审核',
            })
            this.props.NewApproveNextBtn('NewApproveNext2')
          } else {
            this.setState({
              PopUp: '提示弹窗',
              MessageTip: res.errmsg || '上传失败，请稍后重试！',
              Uploading: false,
            })
          }
        })
        .catch((error) => {
          this.setState({
            PopUp: '提示弹窗',
            MessageTip: '网络错误，请稍后重试！',
            Uploading: false,
          })
        })
    } else {
      this.setState({
        PopUp: '提示弹窗',
        MessageTip: '请选择要上传的文件！',
      })
    }
  }

  BackTableInfo = () => {
    this.props.BackTableInfo(this.state.ApproveType)
  }

  componentWillUnmount = () => {
    this.setState = () => {}
  }

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }

  render() {
    const props = {
      UploadState: this.state.UploadBtnState,
      RemoveUpload: (file) => {
        let FileList = this.state.FileList
        let index = FileList.indexOf(file)
        let NewFileList = FileList.slice()
        NewFileList.splice(index, 1)
        this.setState({
          FileList: NewFileList,
          Uploading: false,
          UploadBtnState: 'NotShow',
        })
      },
      BeforeUpload: (file) => {
        let Warn = props.BeforeUpload
        let NewFileList = []
        const excelExtensions = ['.doc', '.docx']
        const fileExtension = file.name
          .substring(file.name.lastIndexOf('.'))
          .toLowerCase()
        const isValidExcel = excelExtensions.includes(fileExtension)
        if (isValidExcel) {
          if (file.size > 20 * 1024 * 1024) {
            Warn['WarnMessage'] = '文件大小不能超过20MB!'
          } else {
            Warn['WarnMessage'] = ''
            NewFileList.push(file)
            this.setState({
              FileList: NewFileList,
              Uploading: false,
              UploadBtnState: 'Show',
            })
          }
        } else {
          Warn['WarnMessage'] =
            '请上传更改申请书的Excel格式文件（.xls 或 .xlsx）'
        }
      },
    }

    const NewAppWorkersInfo = (
      <div>
        <div className={'NewAppWorkersInfo'} style={{ minWidth: 528 }}>
          韩昱老师 ：13671194098
        </div>
        <div className={'NewAppWorkersInfo'} style={{ minWidth: 528 }}>
          杨旭老师 ：15603712839
        </div>
      </div>
    )

    return (
      <div className={'scrollBar'} style={{ height: window.innerHeight - 270 }}>
        <div className={'ApproveMainBox '}>
          {this.state.NewApproveStep === 1 && (
            <div>
              {' '}
              <div className={'ApproveMainStepTitle'}>
                填写更改信息所需申请表
              </div>
              <div className={'NewAppStepDownloadBox'}>
                下载更改信息所需申请表
                <a
                  className={'NewAppStepDownload clearfix'}
                  href={this.state.DownloadBag}
                  download={this.getFileName()}
                >
                  {' '}
                </a>
              </div>
              <div className={'NewApproveUploadBox'}>
                <Upload {...props} />
                <div
                  className={'ActiveUploadFileBtn'}
                  style={
                    this.state.UploadBtnState === 'Show'
                      ? { backgroundColor: '#D2D2D2' }
                      : {}
                  }
                >
                  上传申请书
                </div>
              </div>
              <button
                className={'NewAppStepNext'}
                style={{ marginTop: 180, backgroundColor: '#67C23A' }}
                onClick={
                  this.state.Uploading === true
                    ? null
                    : this.submitChangeBtn.bind(this)
                }
              >
                提交
              </button>
            </div>
          )}
          {this.state.NewApproveStep === 7 && (
            <div className={'NewApproveStepExplanationBox'}>
              <div className={'NewAppExplanationTit'}>
                请您联系工作人员，以安排专家组审核等相关事宜
              </div>
              {NewAppWorkersInfo}
            </div>
          )}
          {this.state.NewApproveStep === 8 && (
            <div className={'NewApproveStepEndBox'}>
              <div className={'NewAppStepEndTitBox clearfix'}>
                <div className={'NewAppStepEndTitIco'}> </div>
                <div className={'NewAppStepEndTitWord'}>恭喜您，审核完成</div>
              </div>
              <div
                className={'BackTableInfo'}
                onClick={this.BackTableInfo.bind(this)}
                style={{ marginTop: 80 }}
              >
                查看已认证{this.state.ApproveType}>>>
              </div>
            </div>
          )}
        </div>
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
      </div>
    )
  }
}

export default ChangeApprove
